<template>
    <li class="menu-item" :key="item.id" :class="active ? 'active' : ''">
        <label
            @click="toggleFilter"
            :class="item.id === 'gas_station' ? 'gasStation' : ''"
        >
            <span class="menu-item__text">{{ item.name }} </span>
            <input type="checkbox" :checked="checkFilters" />
            <span class="checkmark"></span>
        </label>
        <div
            class="sub-filter"
            v-if="selected"
            ref="dropdownToggle"
            @click="clearSubFilter"
        >
            <inline-svg
                name="map/map-filter"
                width="15"
                height="15"
                classes="map-filter"
            ></inline-svg>
        </div>
        <div
            class="child-dropdown"
            @click="toggleDropdown"
            v-if="(parent.children && parent.children.length) || specialOne"
        >
            <inline-svg
                name="map/down-arrow"
                width="10"
                height="10"
                classes="menu-link__dropdown"
            ></inline-svg>
        </div>

        <sub-menu
            v-if="specialOne && active"
            :items="submenuItems"
            :parent="item"
            paramName="rest-areas"
            customClass="child-menu"
        />
    </li>
</template>
<script>
import SubMenu from "./SubMenu.vue";
import inlineSvg from "./inlineSvg.js";
import { mapGetters } from "vuex";
import axios from "./axios.js";

export default {
    name: "SubmenuItem",
    components: {
        inlineSvg,
        SubMenu,
    },

    props: {
        item: {
            default: () => {},
        },
        parent: {
            default: () => {},
        },
        customClass: {
            default: "",
        },
        index: {
            type: Number,
        },
        paramName: {
            type: String,
            default: "categories",
        },
    },

    data() {
        return {
            selected: false,
            specialOne: false,
            submenuItems: [],
            active: false,
        };
    },

    beforeCreate: function () {
        this.$options.components.SubMenu = require("./SubMenu.vue").default;
    },

    mounted() {
        if (this.item.id === "gas_station") {
            this.specialOne = true;
        }
    },

    methods: {
        toggleFilter(e) {
            e.preventDefault();
            this.$store.commit("setModal", null);

            if (!this.checkFilters) {
                if (this.item.category == "restAreas") {
                    if (
                        this.item.id !== "all" &&
                        this.filters[this.item.category] &&
                        this.filters[this.item.category].find(
                            (el) => el == "all"
                        )
                    ) {
                        this.$store.commit("removeFilter", {
                            category: "restAreas",
                            id: "all",
                            name: "map.all",
                            paramKey: "categories",
                        });
                    } else if (this.item.id === "all") {
                        this.$store.commit("resetRestAreaFilters");
                    }
                }

                let payload = { ...this.item };
                this.$store.commit("addFilter", payload);
                if (!this.highwayFilters) {
                    this.getMarkers();
                } else {
                    this.getHighwayMarkers();
                }
            } else {
                let payload = { ...this.item };
                this.$store.commit("removeFilter", payload);
                let category;
                category = this.item.id;
                if (this.item.category === "restAreas") {
                    category = this.item.category;
                }
                if (this.item.category === "gasStationTypes") {
                    category = this.parent.category;
                }

                this.$store.commit("removeMarkers", {
                    ...payload,
                    category: category,
                });
                if (this.highwayFilters) {
                    this.getHighwayMarkers();
                } else if (this.checkRequestFilters) {
                    this.getMarkers();
                }

                if (!this.highwayFilters && this.item.category === "highways") {
                    this.$store.commit("removeHighwayMarkers");
                }
            }
            this.active = !this.active;
        },

        toggleDropdown() {
            this.active = !this.active;
        },

        clearSubFilter() {
            let payload = { category: "gasStationTypes" };

            this.$store.commit("removeFilter", payload);
            this.$store.commit("removeMarkers", {
                payload,
                category: this.item.id,
            });

            if (this.highwayFilters) {
                this.getHighwayMarkers();
            } else if (this.checkRequestFilters) {
                this.getMarkers();
            }
        },

        getMarkers() {
            let urlParam = this.parent.urlKey
                ? this.parent.urlKey
                : this.paramName;
            let url = `${this.url}/${urlParam}`;
            let response = null;
            let paramKey = this.item.paramKey
                ? this.item.paramKey
                : this.item.category;
            let params = {};

            Object.keys(this.filters).forEach((filter) => {
                if (filter === this.item.category) {
                    params[paramKey] = this.filters[filter];
                }
                if (
                    this.item.category === "gasStationTypes" &&
                    filter === this.parent.category
                ) {
                    params["categories"] = this.filters[filter];
                }
                if (
                    this.item.category === "restAreas" &&
                    filter === "gasStationTypes"
                ) {
                    params["gasStationTypes"] = this.filters[filter];
                }
            });

            axios
                .get(url, { params })
                .then((res) => {
                    let data = res.data;
                    if (this.parent.name === "tollPlacesType") {
                        data = this.filterTolls(data);
                    }
                    let category = this.item.id;
                    if (this.item.category === "restAreas") {
                        category = this.item.category;
                    }
                    if (this.item.category === "gasStationTypes") {
                        category = this.parent.category;
                    }
                    response = {
                        category: category,
                        data: data,
                    };
                    this.$store.commit("setMarkers", response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getHighwayMarkers() {
            if (this.filtersNotHighway > 0) {
                if (!Object.keys(this.markers).length) {
                    this.getBackupMarkers();
                }

                let url = this.url;
                let params = {};
                Object.keys(this.filters).forEach((filter) => {
                    if (filter === "tollPlacesType") {
                        params["tollPlaces"] = 1;
                    } else {
                        params[filter] = this.filters[filter];
                    }
                });
                axios
                    .get(url, { params })
                    .then((res) => {
                        this.$store.commit("setHighwayMarkers", res.data);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        getBackupMarkers() {
            let urlParam = this.parent.urlKey
                ? this.parent.urlKey
                : this.paramName;
            let url = `${this.url}/${urlParam}`;
            let response = null;
            let paramKey = this.item.paramKey
                ? this.item.paramKey
                : this.item.category;
            let params = {};

            Object.keys(this.filters).forEach((filter) => {
                if (filter === this.item.category) {
                    params[paramKey] = this.filters[filter];
                }
                if (
                    this.parent.id === "gas_station" &&
                    filter === this.parent.category
                ) {
                    params["categories"] = this.filters[filter];
                }
            });

            axios
                .get(url, { params })
                .then((res) => {
                    let data = res.data;
                    if (this.parent.name === "tollPlacesType") {
                        data = this.filterTolls(data);
                    }

                    let category = this.item.id;
                    if (this.item.category === "restAreas") {
                        category = this.item.category;
                    }

                    if (this.item.category === "gasStationTypes") {
                        category = this.parent.category;
                    }

                    response = {
                        category: category,
                        data: data,
                    };
                    this.$store.commit("setBackupMarkers", response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        filterTolls(data) {
            return data.filter((toll) => {
                if (this.item.id === "enc_regular") {
                    return true;
                } else {
                    return toll[this.item.id];
                }
            });
        },
    },

    computed: {
        ...mapGetters([
            "filters",
            "url",
            "gasStationTypes",
            "filtersCount",
            "highwayFilters",
            "filtersNotHighway",
            "tollPlacesType",
            "markers",
        ]),

        checkFilters() {
            return !!(
                this.filters &&
                this.filters[this.item.category] &&
                this.filters[this.item.category].find(
                    (el) => el === this.item.id
                )
            );
        },

        checkRequestFilters() {
            let isRestArea = this.item.category === "restAreas";
            let isGasStation = this.item.category === "gasStationTypes";
            let isRestFilter =
                this.filters &&
                ((this.filters["gasStationTypes"] &&
                    this.filters["gasStationTypes"].length) ||
                    (this.filters["restAreas"] &&
                        this.filters["restAreas"].length));
            return !!((isRestArea || isGasStation) && isRestFilter);
        },
    },

    watch: {
        filters(newValue) {
            if (this.specialOne) {
                this.selected = !!(
                    newValue &&
                    newValue["gasStationTypes"] &&
                    newValue["gasStationTypes"].length
                );
            }
        },

        specialOne(value) {
            this.submenuItems = this.gasStationTypes.map((station) => ({
                category: "gasStationTypes",
                id: station,
                name: this.trans.get(`map.${station}`),
            }));
        },
    },
};
</script>
